import { upperFirst } from 'lodash';
import { Dispatch, SetStateAction, Ref } from 'react';
import { useTranslation } from 'react-i18next';

import useStore from '../../../store';
import {
  LandlordBooking,
  Status,
  TenantBooking,
} from '../../../types/bookings';
import { BookingInformation } from '../BookingInformation';
import BookingLandlordRegistrationTaxInformation from '../BookingInformation/BookingUserInformation/BookingLandlordUserInformation/BookingLandlordRegistrationTaxInformation';
import { BookingStages } from '../BookingStages/BookingStages';
import {
  StyledBookginDetailsTabItem,
  StyledBookginDetailsTabList,
  StyledCollapsibleContent,
  StyledCollapsibleControl,
  StyledCollapsibleControlArrow,
  StyledCollapsibleControlText,
  StyledDeletedTitle,
  StyledDescriptionList,
  StyledListItem,
  StyledTitle,
  StyledTitleWrapper,
} from './BookingListItem.styles';

interface BookingListItemProps {
  booking: LandlordBooking | TenantBooking;
  setBookings: Dispatch<SetStateAction<LandlordBooking[] | TenantBooking[]>>;
  lastBookingRef: Ref<HTMLLIElement> | null;
}

export function BookingListItem({
  lastBookingRef,
  booking,
  setBookings,
}: BookingListItemProps): JSX.Element {
  const { t } = useTranslation(['booking']);
  const { user } = useStore(state => ({
    user: state.user,
  }));

  return (
    <StyledListItem ref={lastBookingRef} id={booking.id}>
      <div style={{ display: 'none', position: 'absolute' }}>{booking.id}</div>
      <div>
        <StyledTitleWrapper>
          <StyledTitle>{upperFirst(booking.property.address)}</StyledTitle>
          {booking.status === Status.DELETED && (
            <StyledDeletedTitle>Deleted</StyledDeletedTitle>
          )}
        </StyledTitleWrapper>
        {user?.type === 'landlord' && (
          <StyledDescriptionList>
            <dd>
              {booking.tenant.name.first_name} {booking.tenant.name.last_name},{' '}
              {booking.period.start} - {booking.period.end}
            </dd>
          </StyledDescriptionList>
        )}
      </div>

      <StyledCollapsibleControl bookingid={booking.id}>
        <StyledCollapsibleControlText>
          {upperFirst(t('booking:details'))}
        </StyledCollapsibleControlText>
        <StyledCollapsibleControlArrow />
      </StyledCollapsibleControl>
      <StyledCollapsibleContent bookingid={booking.id}>
        {user?.type === 'landlord' && (
          <BookingLandlordRegistrationTaxInformation />
        )}
      </StyledCollapsibleContent>
      <BookingStages booking={booking} />
      <StyledCollapsibleContent bookingid={booking.id}>
        <StyledBookginDetailsTabList>
          <StyledBookginDetailsTabItem user={user?.type}>
            {upperFirst(t('booking:information'))}
          </StyledBookginDetailsTabItem>
        </StyledBookginDetailsTabList>
        <BookingInformation
          booking={booking}
          setBookings={
            setBookings as Dispatch<
              SetStateAction<LandlordBooking[] | TenantBooking[]>
            >
          }
        />
      </StyledCollapsibleContent>
    </StyledListItem>
  );
}
